import { DEMO_SEED_ADMIN_ALIAS, DEMO_SEED_ADMIN_PASSWORD } from '../../demo/demo-seed-credentials';
import { useDemoStore } from '../../demo/store/demo.store';
import { LoginForm } from '../components/LoginForm';

export function LoginPage() {
  const demoHintEnabled = useDemoStore((s) => s.enabled && s.loaded);
  const demoHint = demoHintEnabled
    ? { alias: DEMO_SEED_ADMIN_ALIAS, password: DEMO_SEED_ADMIN_PASSWORD }
    : undefined;

  return (
    <div className="relative isolate min-h-[100dvh] overflow-hidden font-sans lg:grid lg:h-[100dvh] lg:grid-cols-[minmax(0,1fr)_minmax(0,560px)] lg:min-h-0">
      <aside className="relative hidden lg:flex lg:flex-col lg:justify-between lg:p-12">
        <div className="absolute inset-0 -z-10 bg-[radial-gradient(90%_60%_at_10%_-10%,rgba(16,185,129,0.45),transparent),radial-gradient(70%_50%_at_100%_0%,rgba(20,184,166,0.35),transparent),linear-gradient(145deg,#0f172a_0%,#0d4d3f_52%,#134e4a_100%)]" />
        <div className="relative z-[1] text-white drop-shadow-[0_1px_12px_rgba(0,0,0,0.45)]">
          <p className="text-[0.72rem] font-semibold uppercase tracking-[0.2em] text-emerald-200/95">
            Model SaaS
          </p>
          <h2 className="mt-3 max-w-sm text-[1.875rem] font-semibold tracking-tight sm:text-[2.1rem] sm:leading-tight">
            Un espace serein pour organiser vos équipes et vos flux de travail.
          </h2>
          <p className="mt-4 max-w-sm text-[0.95rem] leading-relaxed text-teal-100/90">
            Authentification sécurisée, sessions tracées, administration par rôles — conçu pour
            avancer sereinement.
          </p>
        </div>
        <p className="relative z-[1] text-[0.75rem] text-emerald-200/85">
          Première visite ? Demandez une invitation à votre administrateur ou inscrivez-vous via
          l’API.
        </p>
      </aside>

      <div className="flex min-h-[100dvh] flex-col bg-gradient-to-br from-emerald-50/80 via-white to-[#eef2ff] lg:min-h-0 lg:bg-white">
        <div className="flex flex-1 flex-col justify-center px-6 py-12 sm:px-10 lg:px-14">
          <div className="mx-auto mb-10 flex max-w-xl items-center gap-3 lg:hidden">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-700 text-2xl font-semibold tracking-tighter text-white shadow-lg shadow-teal-700/35">
              M
            </span>
            <div className="min-w-0">
              <p className="truncate text-[0.75rem] font-semibold uppercase tracking-[0.12em] text-slate-500">
                Bon retour
              </p>
              <p className="truncate text-xl font-semibold tracking-tight text-slate-900">
                Model SaaS
              </p>
            </div>
          </div>

          <LoginForm demoHint={demoHint} />

          <p className="mx-auto mt-10 max-w-md text-center text-[0.8rem] text-slate-500 lg:text-left lg:[margin-inline:inherit] lg:text-start">
            En poursuivant, vous acceptez les politiques de sécurité de votre organisation relatives
            à votre compte.
          </p>
        </div>
      </div>
    </div>
  );
}
